import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './ScanCard.LoadingConfig.styles';

const loadingConfig = [
  {
    main: setLoadingConfigObject('circle', 1, 50, styles.icon),
  },
  {
    main: setLoadingConfigObject('line', 2, styles.descriptionDimension, styles.description),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.scanCardButton),
  },
];

export { loadingConfig, shimmerPlaceholderConfig };
